module.exports = __webpack_public_path__ + "img/P150T_weapon_12.802cbbff.png";